.root {
  width: 100%;
  border: 0;
  border-spacing: 0;
  border-collapse: separate;

  th {
    box-sizing: content-box;
    font-weight: var(--fontWeightSemibold);
    height: var(--spacing2xl);
    padding: var(--spacingMd) var(--spacingSm);
  }

  .compactHeader {
    padding: 0 var(--spacingSm);
    height: var(--spacingLg);

    &.withSelectAll {
      padding-top: var(--spacingMd);
      padding-bottom: var(--spacingMd);
    }
  }

  td {
    padding: var(--spacingLg) var(--spacingSm);
    position: relative;
    vertical-align: top;
    line-height: 24px; // temporary set, until tokens are not specified correctly

    &.expandedContent {
      padding: var(--spacingMd) 0;
      padding-left: var(--spacing3xl);
    }

    &.displayGrid:not(:last-child) {
      border-right: 1px solid var(--paletteNeutral0);
    }
  }

  .compactCell {
    padding: var(--spacingMd2) var(--spacingSm);
  }

  .topAlignContent {
    vertical-align: top;
  }

  .alignRight {
    text-align: right;
  }

  .sticky {
    position: sticky;
    right: 0;
  }
}

.header {
  position: sticky;
  top: 0;
  background: var(--paletteWhite0);
  z-index: 10;
  color: var(--paletteBlack1);
  text-align: left;

  &.displayGrid {
    th {
      border-bottom: 1px solid var(--paletteNeutral0);
    }
  }
}

.fixedHeaderWrapper {
  position: fixed;
  top: 0;
  overflow: hidden;
  z-index: 100;
  visibility: hidden;

  table {
    border-spacing: 0;
    border-collapse: separate;
  }
}

.tableResizer {
  overflow: auto;
  overflow-x: unset;
  position: relative;
  width: 100%;

  &.disableInternalScrolling {
    overflow: unset;
  }
}

.row {
  font-weight: var(--fontWeightSemibold);
  font-size: var(--fontSizeRegular);
  align-items: baseline;
}

.rowBody {
  transition: background-color 0.2s ease-in-out;

  &:is(:has(.displayGrid), :not(:last-child)) {
    td {
      border-bottom: 1px solid var(--paletteNeutral0);
    }
  }

  &:not(.noHover):hover {
    background-color: var(--paletteTrans0);
  }
}

.dragging {
  position: relative;
  z-index: 1;
}

.semitransparent {
  opacity: 0.5;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInSemitransparent {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.5;
  }
}

.visibleContent {
  animation: fadeIn 300ms ease-in-out forwards;

  &.semitransparent {
    animation-name: fadeInSemitransparent;
  }
}

.headerButton {
  all: unset;
  display: flex;
  gap: var(--spacingSm);
  align-items: center;
  width: inherit;
  height: 100%;

  &.alignRight {
    margin-left: auto;
  }

  &:focus-visible {
    outline: 2px solid var(--paletteBlue0);
  }
}

.sortableColumn {
  cursor: pointer;
}

.sorting {
  display: flex;
  flex-direction: column;

  svg {
    fill: var(--paletteBlack0);
  }
}

.loadingOverlay {
  width: 100%;
  height: 100%;
  background-color: var(--paletteNeutral2);
  opacity: 0.6;
  position: absolute;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-top: 160px;

  &.loadingOverlayCompact {
    padding-top: 10px;
  }
}

.nestedTable {
  background-color: var(--paletteNeutral2);

  thead {
    background: var(--paletteNeutral2);
    top: 48px; // height of table header
    z-index: 9; // so that nested header hides beneath main header
  }
}

.nestedRow:not(:last-child) .rowBody:last-child td {
  border-bottom: 1px solid var(--paletteNeutral0);
}

.nestedTableHiddenRow {
  height: 0;
  padding: 0;
}

.expanded {
  background-color: var(--paletteNeutral2);
}

.nestedTableEmptyWrapper {
  padding: var(--spacingMd2) var(--spacingSm) var(--spacingMd2) calc(32px + 3 * var(--spacingSm));
  background-color: var(--paletteNeutral2);
  color: var(--paletteBlue2);
}

.expandedContentRow:not(:last-child) {
  td.expandedContent {
    border-bottom: 1px solid var(--paletteNeutral0);
  }
}
